import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ContentLayout } from 'website/components/Layout/components/ContentLayout';
import { LocalizedLink } from 'website/components/LocalizedLink';
import { ROOT_PATHS } from 'routes';

export const UnsubscribeSuccessPage = () => {
  const { t } = useTranslation();
  return (
    <ContentLayout title={t('website:unsubscribeSuccess.pageTitle')}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          py: 10,
          minHeight: '50vh',
        }}
      >
        <Stack gap={2} alignItems="center">
          <Typography variant="h4">{t('website:unsubscribeSuccess.heading')}</Typography>
          <Typography>{t('website:unsubscribeSuccess.description')}</Typography>
          <Button component={LocalizedLink} to={ROOT_PATHS.WEBSITE} variant="contained">
            {t('website:unsubscribeSuccess.backToHomepage')}
          </Button>
        </Stack>
      </Box>
    </ContentLayout>
  );
};
